<template>
  <div>
    <section id="footer">
      <div class="container">
        <el-row>
          <el-col :sm="12" :md="8" :lg="8" :xl="8">
            <div class="each-footer-block">
              <h3 class="footer-title">Give us a call</h3>
              <address>
                <p>
                  <span class="el-icon-message inline-icon"></span>colombo.store@nutron.co.nz
                </p>
                <p>
                  <strong>Retail:</strong>
                  <a href="tel:+64039434442">03 943 4442</a>
                  <br />
                  <strong>Service:</strong>
                  <a href="tel:+64033532232">03 353 2232</a>
                </p>
                <p>
                  <span class="el-icon-location-information inline-icon"></span>678 Colombo ST,
                  <br />
                  <span class="el-icon-location-information inline-icon opacity-0"></span>Christchurch Central,
                  <br />
                  <span class="el-icon-location-information inline-icon opacity-0"></span>Christchurch 8011
                </p>
              </address>
            </div>
            <div class="social-links">
              <a href="https://www.facebook.com/nutronnz/">
                <img src="img/facebook.png" class="icon-button" target="_blank" alt="Facebook" />
              </a>
              <!-- <a href>
                <img src="img/instagram.png" clas="icon-buttn" target="_blank" alt="Instagram" />
              </a>-->
            </div>
          </el-col>
          <el-col :sm="12" :md="8" :lg="8" :xl="8">
            <div class="each-footer-block">
              <h3 class="footer-title">Quick Links</h3>
              <el-row>
                <el-col :sm="24" :md="24" :lg="12">
                  <ul class="footer-links">
                    <!-- <li>
                                        <router-link to="/comingsoon">
                                          <span class="el-icon-d-arrow-right inline-icon"></span>Delivery Information
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/comingsoon">
                                          <span class="el-icon-d-arrow-right inline-icon"></span>Terms &amp; Conditions
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/comingsoon">
                                          <span class="el-icon-d-arrow-right inline-icon"></span>Return Information
                                        </router-link>
                    </li>-->
                    <li>
                      <router-link :to="{ name: 'return-policy' }" exact>
                        <span class="el-icon-d-arrow-right inline-icon"></span>Return Policy
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="{ name: 'about' }">
                        <span class="el-icon-d-arrow-right inline-icon"></span>About
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="{ name: 'faqs' }">
                        <span class="el-icon-d-arrow-right inline-icon"></span>FAQ
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="{ name: 'contact' }">
                        <span class="el-icon-d-arrow-right inline-icon"></span>Contact Us
                      </router-link>
                    </li>
                  </ul>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :sm="15" :md="8" :lg="8" :xl="8">
            <div class="each-footer-block">
              <h3 class="footer-title">Subscribe</h3>
              <p>
                Enter your email address to receive all news, updates on new
                arrivals, special offers and other information.
              </p>
              <div class="subscribe-form">
                <el-form :model="subscribe" class="nutorn-forms">
                  <el-form-item label="Enter Your Email">
                    <el-input v-model="subscribe.email" placeholder="Enter Your Email"></el-input>
                    <small
                      class="error"
                      v-if="getErrors && getErrors['email']"
                    >{{ getErrors["email"] }}</small>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      type="primary"
                      @click="onSubmit"
                      :loading="loading"
                      class="btn subscribe-btn"
                    >Subscribe</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </el-col>
          <el-col :span="24" class="authorize-center-block">
            <img
              src="/img/autherized-reseller.png"
              class="img-fluid authorized-image"
              alt="apple authorized Reseller"
            />
          </el-col>
        </el-row>
      </div>
    </section>
    <section id="copyright">
      <el-row>
        <el-col :lg="8" :md="8" :sm="12">
          <div class="we-accept">
            <ul>
              <li>
                <p>We Accept</p>
              </li>
              <li>
                <img src="/img/icons/mastercard.svg" alt="master-card" class="img-fluid" />
              </li>
              <li>
                <img src="/img/icons/visa.svg" alt="visa-card" class="img-fluid" />
              </li>
              <li>
                <img src="/img/icons/oxipay-logo.svg" alt="Oxipay" class="img-fluid" />
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :lg="16" :md="16" :sm="12">
          <p>
            Copyright © 2019
            <span class="bold">NUTRON™</span>
          </p>
        </el-col>
      </el-row>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      subscribe: {
        email: ""
      },
      offset: Math.floor(window.innerHeight / 2)
    };
  },
  computed: {
    ...mapGetters("errors", ["getMessage", "getErrors"])
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      await this.$store.dispatch("subscribe/subscribe", this.subscribe);
      if (this.getMessage) {
        this.$store.commit("errors/clear");
        this.$message.success(this.getMessage);
      }
      this.loading = false;
      this.resetForm();
    },
    resetForm() {
      this.subscribe.email = "";
    }
  }
};
</script>

<style scoped lang="scss">
#footer {
  padding: 3em 2em 2em 2em;
  background: #f8f8f8;
  color: #767676;

  p {
    margin: 0;
  }

  a {
    color: #767676;
    font-size: 1em;
  }

  .footer-title {
    font-size: 1.2em;
    text-transform: uppercase;
    letter-spacing: 0.2px;
    margin-bottom: 1.2em;
    color: #777;
    font-weight: 600;
    position: relative;
  }

  .inline-icon {
    margin-right: 5px;
    color: #777;
    font-size: 1.05em;
  }

  address {
    font-style: normal;

    p:not(:last-child) {
      margin-bottom: 0.75em;
    }
  }

  .social-links {
    img {
      margin: 10px;
      height: 18px;
      display: flex;
      flex-wrap: wrap;
    }
  }

  .footer-links {
    li:not(:last-child) {
      margin-bottom: 0.75em;
    }
  }

  .subscribe-form {
    margin-top: 0.938em;

    input {
      font-family: "Poppins", sans-serif;
    }

    .subscribe-btn {
      background: #11233f;
      border-radius: 4px;
      color: #fff;
      text-transform: uppercase;
      letter-spacing: 1px;
      font-weight: normal;
      border: none;
      transition: all 0.3s ease-in;
      font-family: "Poppins", sans-serif;
      padding: 10px 12px;
    }

    .subscribe-btn:hover {
      background: #033c92;
    }
  }
}

.authorize-center-block {
  text-align: center;
}

#copyright {
  background: #d3d3d3;
  padding: 0.5em 3em 3px 3em;
  font-size: 0.85em;

  .we-accept {
    ul {
      display: flex;
      align-items: center;

      p {
        text-align: right;
        margin-bottom: 13px;
        font-weight: 600;
      }

      li:not(:last-child) {
        margin-right: 1.25em;
      }

      img {
        width: 3em;
        padding: 0;
      }
    }
  }

  p {
    text-align: right;
    color: #4d4d4d;
    margin-top: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 0;
  }
}

.authorized-image {
  @media all and (min-width: 768px) {
    width: 10% !important;
  }
  @media all and (max-width: 768px) {
    width: 20% !important;
  }
  @media all and (max-width: 460px) {
    width: 80%;
  }
}
</style>
